import { useMemo } from "react"
import * as d3 from "d3"
import { useDimensionsContext } from "./DimensionsProvider"
import { roundNumber } from "./utils"

type AxisProps = {
  domain: number[]
  range: number[]
  roundValues: boolean
}

export const AXIS_HEIGHT = 50

export const Axis = ({ domain = [0, 100], range = [10, 290], roundValues }: AxisProps) => {
  const { boundedHeight } = useDimensionsContext()

  const ticks = useMemo(() => {
    const xScale = d3.scaleLinear().domain(domain).range(range)

    // Specify the desired number of ticks directly.
    const desiredTicks = 10

    return xScale.ticks(desiredTicks).map(value => ({
      value,
      xOffset: xScale(value),
    }))
  }, [domain, range])

  const roundIfEnabled = (value: string | number) =>
    roundValues
      ? roundNumber(value)
      : value?.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })

  return (
    <>
      <path
        d={["M", range[0], 6, "v", -6, "H", range[1], "v", 6].join(" ")}
        fill="none"
        className="stroke-info-lighten-100"
      />
      {ticks.map(({ value, xOffset }) => (
        <g key={value} transform={`translate(${xOffset}, 0)`}>
          <line
            className="stroke-info-lighten-100"
            y1={0}
            strokeDasharray={5.5}
            y2={-boundedHeight}
          />
          <text
            style={{
              fontSize: "10px",
              textAnchor: "middle",
              transform: "translateY(20px)",
            }}
          >
            {roundIfEnabled(value)}
          </text>
        </g>
      ))}
    </>
  )
}
